import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Redirect } from 'react-router-dom';
import PrivateRoute from '../../components/PrivateRoute/PrivateRoute';
import UsersList from './Index';
import UserAddPage from './Add';
import UserEditPage from './Edit';
import { ROLE_ADMIN } from '../../constants/roles';


const propTypes = {
  match: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

const UsersPage = ({ match }) => (
  <Switch>
    <PrivateRoute path={match.url} exact component={UsersList} roles={[ROLE_ADMIN]} />
    <PrivateRoute path={`${match.url}/add`} component={UserAddPage} roles={[ROLE_ADMIN]} />
    <PrivateRoute path={`${match.url}/edit/:id`} component={UserEditPage} roles={[ROLE_ADMIN]} />
    <Redirect to="/users" />
  </Switch>
);

UsersPage.propTypes = propTypes;
export default UsersPage;



// WEBPACK FOOTER //
// ./src/pages/Users/Users.js